<template>
  <div class="section" :class="$mq">
    <div class="title">{{ $t("step2.emptyHouse.title") }}</div>
    <SwitchField
      id="emptyHouse"
      name="emptyHouse"
      v-model="emptyHouse"
      :options="[$t(`step2.consumption.yes`), $t(`step2.consumption.no`)]"
      :default="emptyHouse"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SwitchField from "../../../components/Form/SwitchField.vue";

export default {
  computed: {
    ...mapGetters("energy", ["hasElec"]),
    emptyHouse: {
      get() {
        return this.$store.state.consumption.emptyHouse;
      },
      set(value) {
        this.$store.commit("consumption/setEmptyHouse", value);
      }
    },
  },
  components: {
    SwitchField
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/EmptyHouse.vue